<div class="stick-top">
  <mat-toolbar><mat-icon>emergency</mat-icon> Trouble Tickets</mat-toolbar>
  <div class="hbox lightly-padded button-bar">
    <button mat-raised-button class="primary" routerLink="/tickets/0" >
      <mat-icon>add</mat-icon>
      Create a new Trouble Ticket
    </button>
    <micro-radio style="margin-left: 50px;"
                 spacing="3px"
                 label="Filter on Ticket status:"
                 [options]="[
                    {positive: 'Open', negative: 'Open', value: '0'},
                    {positive: 'Closed', negative: 'Closed', value: '1'},
                    {positive: 'All', negative: 'All', value: 'ALL'}
                    ]"
                 [(value)]="filter.status">
    </micro-radio>
    <div class="fill-space"></div>
    <button mat-raised-button (click)="reloadDebounced()"><mat-icon>refresh</mat-icon> Refresh</button>&nbsp;
    <micro-checkbox [(checked)]="pageSettings.generalSettings.autoRefresh" negative="Auto-Refresh" positive="Auto-Refreshing"></micro-checkbox>&nbsp;
    <micro-date-range [(unit)]="dateRangeSelector.dateRangeUnit" [(from)]="dateRangeSelector.from" [(fromInfinite)]="dateRangeSelector.fromInfinite" [(until)]="dateRangeSelector.until" [(untilInfinite)]="dateRangeSelector.untilInfinite" ></micro-date-range>
  </div>
</div>
<table class="dataTable">
  <thead>
    <tr>
      <th style="width: 100px">
        <div class="vbox">
          Ticket Ref
          <input [(ngModel)]="filter.ticketNumber">
        </div>
      </th>
      <th style="width: 150px;" class="dateTimeHeader">
        Start Time
      </th>
      <th style="width: 120px;">
        Outage
      </th>
      <th style="width: 120px;">
        Resource Type
        <micro-select-combo [(id)]="filter.affectedResourceType"
                            [options]="[
                            {id: 'NE', name: 'NE'},
                            {id: 'SITE', name: 'Site'}
                            ]"
                            [loading]="false"
                         [jump]="false"
                         [placeholder]="'Filter Resource Type'">
        </micro-select-combo>
      </th>
      <th>
        Affected Resource<br>
        <input style="width: 95%;"
               [(ngModel)]="filter.affectedResourceName">
      </th>
      <th style="min-width: 140px;">
        Event Category
        <micro-event-classification-select [classificationType]="'EVENT_CATEGORY'"
                                           [(id)]="filter.eventCategoryId"
                                           [placeholder]="'Filter Event Category'"
                                           [parentId]="undefined">
        </micro-event-classification-select>
      </th>
      <th style="min-width: 140px;">
        Event
        <micro-event-classification-select [classificationType]="'EVENT_TYPE'"
                                           [(id)]="filter.eventTypeId"
                                           [placeholder]="'Filter Event Type'"
                                           [parentId]="filter.eventCategoryId">
        </micro-event-classification-select>
      </th>
      <th style="min-width: 140px;">
        Service Provider
        <micro-event-assignment-select [assignmentType]="'SERVICE_PROVIDER'"
                                       [(id)]="filter.serviceProviderId"
                                       [placeholder]="'Filter Service Provider'"
                                       [parentId]="undefined">
        </micro-event-assignment-select>
      </th>
      <th style="min-width: 140px;">
        Department/Region
        <micro-event-assignment-select [assignmentType]="'DEPARTMENT_REGION'"
                                       [(id)]="filter.departmentId"
                                       [placeholder]="'Filter Department/Region'"
                                       [parentId]="filter.serviceProviderId">
        </micro-event-assignment-select>
      </th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let element of dataSource.data">
      <td [ngClass]="element.status == 1 ?'SUCCESS' : ''"><a routerLink="/tickets/ticketNumber/{{element.ticketNumber}}">{{formatTicketNumber(element.ticketNumber)}}</a></td>
      <td>{{element.startTime | dateTime}}</td>
      <td [ngClass]="outageHours(element.startTime) >= 4 ? 'CRITICAL' : 'WARNING'">{{outageStr(element.startTime)}}</td>
<!--      <td><micro-ne-lookup [neId]="element.destinationId"></micro-ne-lookup></td>-->
      <td>{{element.affectedResourceType}}</td>
<!--      <td><micro-site-lookup [siteId]="element.siteId"></micro-site-lookup></td>-->
      <td>{{element.affectedResourceName}}</td>
      <td>{{element.eventCategory}}</td>
      <td>{{element.event}}</td>
      <td>{{element.serviceProvider}}</td>
      <td>{{element.departmentRegion}}</td>
    </tr>
  </tbody>
</table>

<mat-paginator #paginator
               (page)="reloadDebounced()">
</mat-paginator>
